class RememberMeService {
    constructor(persistenceService) {
        this.KEY = "rememberMe";
        this.persistenceService = persistenceService;
    }

    isRemembered() {
        return this.get() ? true : false;
    }

    get() {
        return this.persistenceService.getAppValue(this.KEY);
    }

    remember(user, server, profile) {
        this.persistenceService.setAppValue(this.KEY, { user, server, profile });
    }

    forget() {
        this.persistenceService.evictAppValue(this.KEY);
    }
}

angular.module('webcomm').service('rememberMeService', ['persistenceService', RememberMeService]);